export function InspectionItemCtrl (
  $uibModal,
  $state,
  $scope,
  $translate,
  $window,
  companyApi,
  confirm,
  messages,
  partstechApi,
  sessionObjAPI
) {
  $scope.currency = sessionObjAPI.currency();
  $scope.company  = sessionObjAPI.company();
  $scope.Company  = companyApi;

  $scope.statusRadios = [
    {
      name : 'green',
      order: 1,
      type : 'success',
      value: 'G'
    },
    {
      name : 'yellow',
      order: 2,
      type : 'warning',
      value: 'Y'
    },
    {
      name : 'red',
      order: 3,
      type : 'danger',
      value: 'R'
    }
  ];

  if ($scope.Company.hasIntegration('partstech')) {
    // Add vehicle id to item so that partstech can find groups
    $scope.item.vehicle_id = $scope.inspection.vehicle_id;
  };

  $scope.addItemsFromPartstech = function () {
    confirm.remember($translate.instant('PARTSTECH_SPACE.INSPECTION_ADD_PRODUCTS_MESSAGE'), null, 'partsTechInspectionAutoSave').then(() => {
      return $scope.inspection.save();
    }).then(inspection => {
      return partstechApi.requestSession('inspection', { ...inspection, item: $scope.item });
    }).then(url => {
      $window.location.assign(url);
    }).catch(err => {
      if (err) {
        messages.error(err);
      }
    });
  };

  $scope.addPartstechLabor = function () {
    partstechApi.addLabor({
      id  : $scope.inspection.id,
      type: 'inspection'
    }, $scope.vehicle)
    .catch(err => {
      messages.error(err);
    })
    .finally(() => {
      $state.reload();
    });
  };

  $scope.checkType = function (type) {
    return $scope.item.inspection_type === type;
  };

  $scope.isUrgent = function () {
    return ($scope.checkType('GYR') && $scope.item.input1 === 'R') ||
      (!$scope.checkType('GYR') && $scope.item.needs_attention_urgent);
  };

  $scope.needsAttention = function () {
    return $scope.isUrgent() ||
      ($scope.checkType('GYR') && $scope.item.input1 === 'Y') ||
      (!$scope.checkType('GYR') && $scope.item.needs_attention_soon);
  };

  $scope.toggle = function (evt) {
    $scope.$broadcast('toggle');
  };

  $scope.$watch('item.input1', function (newVal, oldVal) {
    if ($scope.checkType('GYR') && newVal !== oldVal) {
      if (newVal === 'R') {
        if (!$scope.item.hide_estimated_hours || !$scope.item.hide_estimated_cost) {
          $scope.item.isOpen = true;
        }

        $scope.item.estimated_time = $scope.item.estimated_time || $scope.item.estimated_time_red;
        $scope.item.needs_attention_urgent = true;
        $scope.item.needs_attention_soon   = false;
      }
      else if (newVal === 'Y') {
        if (!$scope.item.hide_estimated_hours || !$scope.item.hide_estimated_cost) {
          $scope.item.isOpen = true;
        }

        $scope.item.estimated_time = $scope.item.estimated_time || $scope.item.estimated_time_yellow;
        $scope.item.needs_attention_urgent = false;
        $scope.item.needs_attention_soon   = true;
      }
      else if (newVal === 'G') {
        $scope.item.needs_attention_urgent = false;
        $scope.item.needs_attention_soon   = false;
      }
      else {
        $scope.item.isOpen = false;
      }
    }
  });

  $scope.$watch('item.needs_attention_urgent', function (value) {
    if (value) {
      $scope.item.needs_attention_soon = false;
    }
  });

  $scope.$watch('item.needs_attention_soon', function (value) {
    if (value) {
      $scope.item.needs_attention_urgent = false;
    }
  });

  if (!$scope.checkType('GYR') && !$scope.checkType('CO')) {
    $scope.item.isOpen = true;
  }
  else if ($scope.checkType('GYR') && $scope.item.input1 && $scope.item.input1 !== 'G') {
    $scope.item.isOpen = true;
  }
  else {
    $scope.item.isOpen = false;
  }
};